<script>
const transOperator = type => {
    let value
    switch (type) {
        case 'add': {
            value = '+'
            break
        }
        case 'multiply': {
            value = '*'
            break
        }
        case 'minus': {
            value = '-'
            break
        }
        case 'divide': {
            value = '/'
            break
        }
    }
    return value
}
export default {
    name: 'InputComputed',
    data() {
        return {
            eventObject: {},
            // 规则
            operator: undefined,
            formatValue: ''
        }
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false
        },
        calculationRules: {
            type: Object,
            default: undefined
        }
    },
    created() {
        const { relation, operator } = this.calculationRules
        this.operator = operator
        const { eventHub } = this.$attrs
        if ( relation && operator ) {
            relation.map(item => {
                // 订阅事件
                this.$set(this.eventObject, item, undefined)
                eventHub.on(item, (data) => {
                    console.log(`${item}输入了${data}`)
                    this.eventObject[item] = data
                    this.formatValue = this.computedValue(this.eventObject[item])
                    this.$emit('input', String(this.formatValue))
                })
            })
        }
    },
    watch: {
        value: {
            handler(value) {
                this.formatValue = value
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        computedValue() {
            const keys = Object.keys(this.eventObject)
            const { operator } = this
            let value
            const { formData } = this.$attrs
            // 修改时 将表单数据 自动赋值 给this.eventObject中 以满足{编辑}过程中只修改其中一个，也要计算结果
            keys.map(key => {
                // 如果无值的话 讲 formData中的值赋上
                if(!!!this.eventObject[key]) {
                    this.eventObject[key] = formData[key]
                }
            })
            const allHaveValue = keys.every(key => this.eventObject[key])
            if(allHaveValue) {   
                let str = '' 
                operator.map(item => {
                    str = str + `${this.eventObject[item.value]}${item.operator ? transOperator(item.operator) : ''}`
                })
                try {
                    value = eval(str)
                } catch {
                    value = NaN
                }
            } else {
                value = this.formatValue
            }
            return value
        }
    },
    beforeDestroy() {
        // 销毁发布订阅器
        const { relation } = this.calculationRules
        const { eventHub } = this.$attrs
        if(relation) {
            relation.map(item => {
                eventHub.off(item)
            })
        }
    },
    render() {
        return (
            <el-input value={this.formatValue} onInput={value => {this.formatValue = value; this.$emit('input', value)}} placeholder="请输入内容"></el-input>
        )
    }
}
</script>
